import {
  post
} from '@/common/http.js'

export const getKeywordsCost = params => post('keyword/cost', params)
export const getOrderList = params => post('order/index', params) //	任务列表
export const getTaskDetail = params => post('order/detail', params) //	任务详情
export const getSiteFtp = params => post('operation/site/ftpAndManagerDetail', params) //	站点ftp详情
export const updateSiteFtp = params => post('operation/site/ftpAndManagerUpdate', params, {}, true) //	站点ftp修改
export const getSiteCoupon = params => post('order/renew/coupon', params) //	获取该站点的优惠券
export const savePayParams = params => post('order/renew/save_params', params) //	续费/续预存 保存支付信息
export const getPayInfo = params => post('order/renew/pay/info', params) //	续费/续预存 获取支付信息
export const rechargePay = params => post('order/renew/pay', params) //	续费/续预存支付
export const checkIsPay = params => post('pay/is_pay', params) //	是否支付成功
export const wxPay = params => post('pay/payment_in_wx', params) //	微信内部微信支付

export const keywordList = params => post('keyword/rank', params) //	关键词列表
export const searchKeywordPrice = params => post('keyword/query_price', params) //	查词
export const workorderAddWord = params => post('workorder/add/word', params) //	加词
export const workorderStopWord = params => post('operation/task_applyStopWord', params) //	停词
export const checkHasFtp = params => post('check/site/info', params) //	检测ftp和后台管理地址是否完善

export const getBalance = params => post('finance/companyBalance', params) //	获取账户余额

// 发布任务
export const getAgreementInfo = params => post('order/publish/agreement_info', params) //	获取协议信息
export const confirmAgreement = params => post('order/publish/agreement', params) //	确认协议
// 第一步
export const getFirstInfo = params => post('order/publish/step1/info', params) //	有站点时，获取相关信息
export const updateFirstStep = params => post('order/day/step1/update', params) //	有站点提交
export const submitFirstStep = params => post('order/day/step1', params) //	无站点提交

// 第二步
export const getSecondInfo = params => post('order/day/step2/info', params) //	获取基本信息
export const get5188 = params => post('5118/words_price', params) //	获取基本信息
export const getHistoryRecord = params => post('keyword/history', params) //	查询搜索记录
export const submitSecondStep = params => post('order/day/step2', params) //	提交
export const updateSecondStep = params => post('order/day/edit', params) //	重发

// 第三部
export const getThirdInfo = params => post('order/publish/step3/info', params) //	获取基本信息
export const getPackageInfo = params => post('order/day/package_info', params) //	获取套餐信息
export const goPay = params => post('order/publish/step3', params) //	去支付

// 支付
export const getTaskPayInfo = params => post('order/publish/pay/info', params) //	获取支付信息
export const payTask = params => post('order/publish/pay', params) //	支付
export const isPaySuccess = params => post('/pay/is_pay', params) //	检验是否完成支付

// 分享
export const shareSite = params => post('keyword/share/site', params) //	分享站点
export const shareWord = params => post('keyword/share/word', params) //	分享关键词

// 申请架次
export const filterWord = params => post('keyword/filter_query', params)
export const getMinSeviceFee = params => post('order/day/service_fee', params) // 获取最低服务费



// WEBPACK FOOTER //
// ./src/api/task.js